import {AfterViewInit, Component, Inject, QueryList, ViewChild} from '@angular/core';
import {DialogResult, DialogResultType} from '../DialogResult';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {InteractPoDPage} from '../../api/models/interact-po-dpage';
import {Observable} from 'rxjs/internal/Observable';
import {MatList, MatListOption, MatSelectionList, MatSelectionListChange} from '@angular/material/list';
import {AzureConfig} from '../../api/models/azure-config';
import {AwsConfig} from '../../api/models/aws-config';
import {SftpConfig} from '../../api/models/sftp-config';
import {EmailConfig} from '../../api/models/email-config';
import {DataOnDemandDestinationType} from '../data-on-demand-layout-dialog/data-on-demand-layout-dialog.component';

export enum DataOnDemandFileType {
  CSV = 0,
  XLSX = 1,
  JSON = 2,
  XML = 3
}

export class DataOnDemandDialogData {
  fileType: DataOnDemandFileType;
  notificationEmail: string;
  destinationId: number;
  azureConfig?: AzureConfig;
  awsConfig?: AwsConfig;
  sftpConfig?: SftpConfig;
  emailConfig?: EmailConfig;
}

export class DataOnDemandDialogResult {
  fileType: DataOnDemandFileType;
  notificationEmail: string;
  destinationId: number;
  azureConfig?: AzureConfig;
  awsConfig?: AwsConfig;
  sftpConfig?: SftpConfig;
  emailConfig?: EmailConfig;
}

@Component({
  selector: 'data-on-demand-dialog',
  templateUrl: './data-on-demand-dialog.component.html',
})
export class DataOnDemandDialogComponent {

  results: DataOnDemandDialogResult = {
    fileType: DataOnDemandFileType.CSV,
    notificationEmail: 'example@example.com',
    destinationId: DataOnDemandDestinationType.Email
  };

  destinationId: number;

  azureConfig: AzureConfig = {
    connectionString: "",
    containerName: "",
    path: ""
  };

  awsConfig: AwsConfig = {
    accessKey: "",
    secretKey: "",
    region: "",
    bucketName: "",
    path: ""
  };

  sftpConfig: SftpConfig = {
    host: "",
    port: 0,
    userName: "",
    password: "",
    path: ""
  };

  emailConfig: EmailConfig = {
    emailAddress: ""
  };

  constructor(
    public dialogRef: MatDialogRef<DataOnDemandDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DataOnDemandDialogData
  ) {

    this.destinationId = data.destinationId;
    this.results.notificationEmail = data.notificationEmail;

    if (this.destinationId == DataOnDemandDestinationType.Email) {
      this.emailConfig.emailAddress = data.emailConfig?.emailAddress ?? "example@example.com"
    } else if (this.destinationId == DataOnDemandDestinationType.Sftp) {
      this.sftpConfig.host = data.sftpConfig?.host ?? "example.com"
      this.sftpConfig.port = data.sftpConfig?.port ?? 22
      this.sftpConfig.userName = data.sftpConfig?.userName ?? "example"
      this.sftpConfig.password = data.sftpConfig?.password ?? "example"
      this.sftpConfig.path = data.sftpConfig?.path ?? "/"
    } else if (this.destinationId == DataOnDemandDestinationType.AzureBlob) {
      this.azureConfig.connectionString = data.azureConfig?.connectionString ?? "DefaultEndpointsProtocol=https;AccountName=example;AccountKey=example;EndpointSuffix=core.windows.net";
      this.azureConfig.containerName = data.azureConfig?.containerName ?? "example";
      this.azureConfig.path = data.azureConfig?.path ?? "/";
    } else if (this.destinationId == DataOnDemandDestinationType.AWS) {
      this.awsConfig.accessKey = data.awsConfig?.accessKey ?? "example";
      this.awsConfig.secretKey = data.awsConfig?.secretKey ?? "example";
      this.awsConfig.region = data.awsConfig?.region ?? "us-east-1";
      this.awsConfig.bucketName = data.awsConfig?.bucketName ?? "example";
      this.awsConfig.path = data.awsConfig?.path ?? "/";
    }

    this.results.fileType = data.fileType;

    this.Result = new DialogResult();
    this.Result.ResultType = DialogResultType.Cancel;
    this.Result.ResultData = null;
  }

  public Result: DialogResult;

  static showDialog(
    dialog: MatDialog,
    fileType: DataOnDemandFileType,
    notificationEmail: string,
    destinationId: number,
    azureConfig?: AzureConfig,
    awsConfig?: AwsConfig,
    sftpConfig?: SftpConfig,
    emailConfig?: EmailConfig
  ): Observable<any> {
    const params: DataOnDemandDialogData = {
      fileType,
      notificationEmail,
      destinationId,
      azureConfig,
      awsConfig,
      sftpConfig,
      emailConfig
    };

    const dialogRef = dialog.open(DataOnDemandDialogComponent, {
      disableClose: true,
      width: '750px',
      data: params,
    });

    return dialogRef.afterClosed();
  }

  onCancelClick(): void {
    this.dialogRef.close(this.Result);
  }

  onConfirmClick(): void {

    this.results.destinationId = this.destinationId;

    if (this.destinationId == DataOnDemandDestinationType.Email) {
      this.results.emailConfig = this.emailConfig;
      this.results.sftpConfig = undefined;
      this.results.azureConfig = undefined;
      this.results.awsConfig = undefined;
    } else if (this.destinationId == DataOnDemandDestinationType.Sftp) {
      this.results.emailConfig = undefined;
      this.results.sftpConfig = this.sftpConfig;
      this.results.azureConfig = undefined;
      this.results.awsConfig = undefined;
    } else if (this.destinationId == DataOnDemandDestinationType.AzureBlob) {
      this.results.emailConfig = undefined;
      this.results.sftpConfig = undefined;
      this.results.azureConfig = this.azureConfig;
      this.results.awsConfig = undefined;
    } else if (this.destinationId == DataOnDemandDestinationType.AWS) {
      this.results.emailConfig = undefined;
      this.results.sftpConfig = undefined;
      this.results.azureConfig = undefined;
      this.results.awsConfig = this.awsConfig;
    }

    this.finishDialog();
  }

  private finishDialog(): void {
    this.Result.ResultType = DialogResultType.Ok;
    this.Result.ResultData = this.results;
    this.dialogRef.close(this.Result);
  }
}
